import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy Norwegian route — permanent redirect to the German path
export const Route = createFileRoute("/gå-til")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/zum-anbieter", search: search as never, statusCode: 301 });
  },
});
